import axios from 'axios'
import { Message } from 'element-ui'
import Qs from 'qs'
// import { getToken } from '@/utils/auth'

let myBaseURL = process.env.VUE_APP_BASE_API
localStorage.setItem('baseURL', myBaseURL)
const service = axios.create({
  baseURL: myBaseURL, 
  timeout: 5000 // 请求超时时间
})

//这是post请求，可以直接发送对象
service.defaults.transformRequest = [(data)=> {return Qs.stringify(data)}]

// 可以在请求头添加对应信息
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
  // config.headers['Authorization'] = getToken()
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})


/**
* respone拦截器
* 对请求返回的错误进统一处理
*/
service.interceptors.response.use(
  response => {
    // console.log('response',response)
	  /**
	  * 对接口请求成功返回的错误进统一处理
		*/
    const res = response.data
    // console.log('request',res)
    // code大于40000的为全局错误码，
    if(res.status > 200) {
      // 401：接口权限不足
      if(res.status == 401) {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }else{
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(res.message)
    }

    // code小于200的，为不可预料的错误码
    if (res.code < 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res.message)
    } 
    
    // code为200视为正常
    return response.data
  },
  error => {
  	/*
  	* 对接口请求失败进行统一处理
  	*/
    console.log('err:' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    // return Promise.reject(error)
  }
)

export default service
